import { registerPlugin } from '@capacitor/core';
export const SalaNoCelular = registerPlugin('SalaNoCelular');
